import { Tooltip } from '@servicetitan/anvil2';
import { ReactElement } from 'react';
import classNames from 'classnames';
import styles from './CallControlsTooltip.module.css';

interface CallControlsTooltipProps {
  children: ReactElement;
  text: string;
  tooltipClassName?: string;
  contentId?: string;
  open?: boolean;
  offset?: number;
}

/* Tooltip offset for button element in CallControl bar */
export const BUTTON_OFFSET = 18;

/* Tooltip offset for text element in CallControl bar */
export const TEXT_OFFSET = 26;

export const CallControlsTooltip = ({
  children,
  text,
  tooltipClassName,
  contentId,
  open,
  offset = BUTTON_OFFSET,
}: CallControlsTooltipProps) => {
  if (!text) {
    return children;
  }
  return (
    <Tooltip offset={offset} open={open}>
      <Tooltip.Trigger>
        <span tabIndex={0}>{children}</span>
      </Tooltip.Trigger>
      <Tooltip.Content
        data-testid={contentId}
        className={classNames(styles.TooltipWrapper, tooltipClassName)}
      >
        {text}
      </Tooltip.Content>
    </Tooltip>
  );
};
